import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemBirthday = function IconSystemBirthday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 16,
    strokeWidth: 2,
    d: "M12 6.857V9.29m0-2.434c1.358 0 2.004-1.135 2.004-1.953 0-.67-.865-1.922-1.573-2.968a.523.523 0 0 0-.86 0c-.707 1.046-1.567 2.297-1.567 2.968 0 .918.639 1.953 1.996 1.953Zm0 2.434H5.718A3.719 3.719 0 0 0 2 13.009m10-3.718h6.281A3.719 3.719 0 0 1 22 13.009m-20 0 1.164 1.342c.678.796 1.98.66 2.586-.193a1.533 1.533 0 0 1 2.5 0c.61.861 1.889.861 2.5 0a1.533 1.533 0 0 1 2.5 0c.61.861 1.889.861 2.5 0a1.533 1.533 0 0 1 2.5 0c.605.853 1.908.989 2.586.193L22 13.01m-20 0v4.983m20-4.983v4.983m-20 0v1.798a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-1.798m-20 0h20"
  }));
};